// csgo外观
const shopAppearance = [{
		type: 1,
		text: '崭新出厂'
	},
	{
		type: 2,
		text: '略有磨损'
	},
	{
		type: 3,
		text: '久经沙场'
	},
	{
		type: 4,
		text: '破损不堪'
	},
	{
		type: 5,
		text: '战痕累累'
	},
	{
		type: 6,
		text: '无涂装'
	},
	{
		type: 7,
		text: ''
	}
]
export default shopAppearance
